export default __webpack_public_path__ + "static/media/player_8.1c0acc14.mp3";